import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  AddGroupAPI,
  GetAllGroups,
  UpdateGroupAPI,
} from "../../../../../actions";
import Modal from "../../../../../components/Modal";
import MyPasswordInput from "../../../../../components/MyPasswordInput";
import MyTextInput from "../../../../../components/MyTextInput";
import { errorToast } from "../../../../../helpers/toasts";
import { IsEmpty } from "../../../../../helpers/utils";
import {
  setEditDeviceData,
  setEditGroupData,
  setIsLoading,
} from "../../../../../redux/slices/userSlice";
import { v4 as uuidv4 } from "uuid";

const AddGroup = (props) => {
  const [groupName, setGroupName] = useState("");
  const [groupId, setGroupId] = useState("");
  const [edit, setEdit] = useState("");
  const [iconName, setIconName] = useState(null);

  const isLoading = useSelector((state) => state.user.isLoading);
  const editGroupData = useSelector((state) => state.user.editGroupData);

  const dispatch = useDispatch();

  useEffect(() => {
    if (editGroupData) {
      //   alert(editGroupData);
      setGroupName(editGroupData?.name);
      setEdit("1");
      setGroupId(editGroupData?.id);
      dispatch(setEditGroupData(null));
    }
  }, [editGroupData]);

  const Add = async () => {
    if (IsEmpty(groupName)) {
      errorToast("Group Name is required");
      return;
    }

    // if (IsEmpty(uniqueId) && deviceType === "1") {
    //   errorToast("Unique ID is required");
    //   return;
    // }

    dispatch(setIsLoading(true));

    await AddGroupAPI(dispatch, {
      name: groupName,
    })
      .then(async () => {
        setGroupName("");
        setGroupId("");
        await GetAllGroups(dispatch);
        dispatch(setIsLoading(false));
      })
      .catch((e) => {
        dispatch(setIsLoading(false));
      });
  };

  const emptyFields = (emptyEdit = true) => {
    setGroupName("");
    setGroupId("");
    if (emptyEdit) {
      setEdit(null);
    }
  };

  const update = async () => {
    if (IsEmpty(groupId)) {
      errorToast("Group Id is required");
      return;
    }
    if (IsEmpty(groupName)) {
      errorToast("Group Name is required");
      return;
    }

    dispatch(setIsLoading(true));

    await UpdateGroupAPI(dispatch, {
      groupId,
      name: groupName,
    })
      .then(async () => {
        setGroupName("");
        setGroupId("");
        await GetAllGroups(dispatch);
        dispatch(setIsLoading(false));
      })
      .catch((e) => {
        dispatch(setIsLoading(false));
      });
  };

  return (
    <>
      <Modal
        title={edit ? "Update Group" : "Add Group"}
        name={"addGroup"}
        icon={"fa-solid fa-people-roof"}
      >
        <div className="col-12">
          <a href="#" className="nav-link">
            <i
              style={{ fontSize: "20px" }}
              className="fa fa-light fa-arrow-left"
              onClick={() => {
                setEdit(null);
                emptyFields();
              }}
              title="Go To List"
              data-bs-dismiss="modal"
              aria-label="Close"
              data-bs-toggle="modal"
              data-bs-target={"#listGroups"}
            ></i>
          </a>
        </div>
        <form>
          <>
            <div className="row">
              <div className="mb-4 col-4">
                <MyTextInput
                  name={"Group Name"}
                  val={groupName}
                  placeholder={"Group Name"}
                  setVal={setGroupName}
                />
              </div>
            </div>

            <br />
            <div className="row">
              <div className="col-4"></div>
              <div className="col-4" style={{ textAlign: "center" }}>
                {isLoading ? (
                  <button className="btn btn-primary" type="button" disabled>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>{" "}
                    &nbsp; Loading...
                  </button>
                ) : edit ? (
                  <button
                    type="submit"
                    className="btn btn-primary w-50"
                    onClick={(e) => {
                      e.preventDefault();
                      update();
                    }}
                  >
                    Update Group
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="btn btn-primary w-50"
                    onClick={(e) => {
                      e.preventDefault();
                      Add();
                    }}
                  >
                    Add Group
                  </button>
                )}
              </div>
            </div>
            <br />
          </>
        </form>
      </Modal>
    </>
  );
};

export default AddGroup;
